import React, { useEffect, useContext, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Row, Col, Container, Card } from "react-bootstrap";
import styled from "styled-components";
import ClipLoader from "react-spinners/CircleLoader";
import ReactGA from "react-ga";
import ImageLoader from "./../../components/ImageLoader";
import Header from "../../components/Header";
import Audio from "../../components/Audio";
import Video from "../../components/Video";
import { checkData } from "../../hoc";
import { AppContext } from "../../AppContext";

import NEXTSVG from "./../../assets/svg/next1.svg";
import NEXTPRESSSVG from "./../../assets/svg/next2.svg";
import BACKSVG from "./../../assets/svg/back1.svg";
import BACKPRESSSVG from "./../../assets/svg/back2.svg";

const ContainerWrapper = styled(Container)`
  margin-top: 130px;
  margin-bottom: 30px;
`;

const ImgBackControl = styled.div`
  height: 50px;
  cursor: pointer;

  background-image: url('${BACKSVG}');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  width: 50px;
  height: 50px;
  cursor:pointer;
  &:focus,&:hover{
    background-image: url('${BACKPRESSSVG}');
  }
`;

const ImgNextControl = styled.div`
  height: 50px;
  cursor: pointer;

  background-image: url('${NEXTSVG}');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  width: 50px;
  height: 50px;
  cursor:pointer;
  &:focus,&:hover{
    background-image: url('${NEXTPRESSSVG}');
  }
`;

const DivSpace = styled.div`
  height: 50px;
  width: 50px;
`;

const CardWrapper = styled(Card)`
  box-shadow: 8px 8px 5px #dfdedb;
  &:focus,
  &:hover {
    box-shadow: 10px 10px 5px #dfdedb;
  }
`;

const CardTitle = styled(Card.Title)`
  font-family: Copernicus-Bold;
  color: #150f15;
  font-size: 2em;
`;
const CardText = styled(Card.Text)`
  font-family: HelveticaNeue-Italic;
  margin-bottom: 0;
  letter-spacing: 1px;
  font-style: italic;
  font-size: 17px;
  font-weight: bold;
`;
const CardText2 = styled(Card.Text)`
  font-family: HelveticaNeue-Regular;
  margin-bottom: 0;
  letter-spacing: 2px;
  font-size: 16px;
  font-weight: 700;
`;
const useWindowHeight = () => {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return height;
};

const Artwork = () => {
  let history = useHistory();
  let { collectionId, artworkId } = useParams();
  const { collections, language, filter } = useContext(AppContext);

  const [artwork, setArtwork] = useState(null);
  const [artworks, setArtworks] = useState([]);
  const [height] = useState(useWindowHeight());

  useEffect(() => {
    fetchArtwork();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionId, artworkId]);

  const fetchArtwork = async () => {
    if (collectionId) {
      if (filter) {
        filterCollections();
      } else {
        const dataCol = collections.filter((item) => {
          return parseInt(item.id) === parseInt(collectionId);
        });
        if (dataCol.length) {
          setArtworks(sorts(dataCol[0].obras));
          const data = dataCol[0].obras.filter((item) => {
            return parseInt(item.id) === parseInt(artworkId);
          });

          if (data.length) {
            runGA(data[0]);
            setArtwork(data[0]);
          }
        }
      }
    }
  };

  const filterCollections = () => {
    if (filter.type === "room") {
      const data = collections.filter((item) => {
        return parseInt(item.id) === parseInt(collectionId);
      });
      const obras = data[0].obras.filter((item) => {
        return !item.autor;
      });
      setArtworks(sorts(obras));
      const art = obras.filter((item) => {
        return parseInt(item.id) === parseInt(artworkId);
      });
      if (data.length) {
        setArtwork(art[0]);
      }
      return;
    }

    if (filter.type === "artwork") {
      const data = collections.filter((item) => {
        return parseInt(item.id) === parseInt(collectionId);
      });
      const obras = data[0].obras.filter((item) => {
        return item.autor;
      });
      setArtworks(sorts(obras));
      const art = obras.filter((item) => {
        return parseInt(item.id) === parseInt(artworkId);
      });
      if (data.length) {
        setArtwork(art[0]);
      }
      return;
    }

    if (filter.type === "floor") {
      const data = collections.filter((item) => {
        return parseInt(item.id) === parseInt(collectionId);
      });
      const obras = data[0].obras.filter((item) => {
        return item.planta === filter.floorFilter;
      });
      setArtworks(sorts(obras));
      const art = obras.filter((item) => {
        return parseInt(item.id) === parseInt(artworkId);
      });
      if (data.length) {
        setArtwork(art[0]);
      }
      return;
    }

    setArtworks(sorts(filter.obras));
    const art = filter.obras.filter((item) => {
      return parseInt(item.id) === parseInt(artworkId);
    });
    if (art.length) {
      setArtwork(art[0]);
    }
  };

  const sorts = (array) => {
    for (let i = 0; i < array.length - 1; i++) {
      for (let j = i + 1; j < array.length; j++) {
        if (parseInt(array[i].orden) > parseInt(array[j].orden)) {
          let aux = array[i];
          array[i] = array[j];
          array[j] = aux;
        }
      }
    }
    return array;
  };

  const prev = () => {
    for (let i = 0; i < artworks.length; i++) {
      if (artworks[i].id === artwork.id) {
        if (i + 1 < artworks.length) {
          history.push(
            `/collection/${collectionId}/artwork/${artworks[i + 1].id}`
          );
        } else {
          history.push(`/collection/${collectionId}/artwork/${artworks[0].id}`);
        }
      }
    }
  };

  const next = () => {
    for (let i = 0; i < artworks.length; i++) {
      if (artworks[i].id === artwork.id) {
        if (i - 1 >= 0) {
          history.push(
            `/collection/${collectionId}/artwork/${artworks[i - 1].id}`
          );
        } else {
          history.push(
            `/collection/${collectionId}/artwork/${
              artworks[artworks.length - 1].id
            }`
          );
        }
      }
    }
  };

  const runGA = (item) => {
    ReactGA.event({
      category: "Atwork",
      action: `Visited -${item.titulo[language.abreviatura]}`,
      value: parseInt(artworkId),
    });
  };

  return (
    <React.Fragment>
      <Header />
      <ContainerWrapper id="artwork">
        {!artwork && (
          <Row style={{ marginTop: 260 }}>
            <Col className="d-flex justify-content-center">
              <ClipLoader size={100} color={"#439eae"} loading={true} />
            </Col>
          </Row>
        )}

        {artwork && artwork.titulo[language.abreviatura] && (
          <React.Fragment>
            <Row className="sg-container d-flex justify-content-center">
              <Col className="m-2 col-12 d-flex justify-content-center">
                <CardWrapper>
                  {(!artwork.es_sala || artwork.es_sala === "0") &&
                    artwork.imagen_id && (
                      <ImageLoader
                        key={`image-${artwork.imagen_id}`}
                        id={artwork.imagen_id}
                        obra={artwork.id}
                        height={height}
                      />
                    )}
                  <Card.Body>
                    <CardTitle>
                      {artwork.autor
                        ? artwork.autor
                        : ` ${
                            artwork.es_sala === "1"
                              ? artwork.sala_id
                                ? `${language && language.SALA} ${
                                    artwork.sala_id
                                  }`
                                : ""
                              : ""
                          }`}
                      &nbsp;
                    </CardTitle>
                    <Row>
                      <Col className="col-12">
                        <CardText>
                          {artwork.titulo[language && language.abreviatura]}
                          &nbsp;
                        </CardText>
                        <CardText2>
                          {` ${
                            artwork.planta
                              ? `${language && language.PLANTA} ${
                                  artwork.planta
                                }`
                              : ""
                          } `}{" "}
                          {`${
                            artwork.planta &&
                            artwork.sala_id &&
                            (artwork.es_sala === "0" ||
                              artwork.es_sala === null)
                              ? "-"
                              : ""
                          } `}
                          {` ${
                            artwork.sala_id &&
                            (artwork.es_sala === "0" ||
                              artwork.es_sala === null)
                              ? `${language && language.SALA} ${
                                  artwork.sala_id
                                }`
                              : ""
                          }`}
                        </CardText2>
                      </Col>
                    </Row>
                    <Row className="mt-4 d-flex justify-content-center">
                      <Col className="mt-4 d-flex justify-content-between col-12 mb-4">
                        <ImgBackControl onClick={next} />
                        {!(Object.keys(artwork.audio).length > 0 && DivSpace)}
                    
                        <ImgNextControl onClick={prev} />
                      </Col>
                    </Row>
                    {Object.keys(artwork.audio).length > 0 &&
                      artwork.audio[language.abreviatura] && (
                        <Row className="d-flex justify-content-center mb-5">
                          <Audio
                            audioId={artwork.audio[language.abreviatura]}
                            name={artwork.titulo[language.abreviatura]}
                          />
                        </Row>
                      )}
                    <Row>
                      {Object.keys(artwork.video).length > 0 &&
                        artwork.video[language.abreviatura] && (
                          <Video
                          key={`video-key-${artwork.video[language.abreviatura]}`}
                            videoId={artwork.video[language.abreviatura]}
                            name={artwork.titulo[language.abreviatura]}
                          />
                        )}
                    </Row>
                  </Card.Body>
                </CardWrapper>
              </Col>
            </Row>
          </React.Fragment>
        )}
      </ContainerWrapper>
    </React.Fragment>
  );
};

export default checkData(Artwork);
